import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { UserContext } from "services/useContext";
import { useSelector } from "react-redux";
import { Button } from "reactstrap";
import { DatePicker } from "reactstrap-date-picker";
import Select, { components } from "react-select";
import moment from "moment";
import {
  quotationList,
  userCSCMappingList,
  userCustomerList,
  userMasterActiveList,
  quotationDelete,
} from "api";
import { paginationList, columnPricingTableData } from "content/static.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPencil,
  faPlus,
  faTrash,
  faArrowRotateRight,
} from "@fortawesome/free-solid-svg-icons";
import DeleteComponent from "../components/DeleteComponent";
import Loading from "../components/Event/Loading";
import "./Pricing/Pricing.css";

const PricingTable = () => {
  const [data, setData] = useState([]);
  const [toDate, setToDate] = useState("");
  const [fromDate, setFromDate] = useState(""); // eslint-disable-next-line
  const [searchInput, setSearchInput] = useState("");
  const [page, setPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(25);
  const selectPageLimitRef = useRef(null);
  const currentUser = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [quotationIdToDelete, setQuotationIdToDelete] = useState(null);
  const [cscMaster, setCscMaster] = useState([]);
  const [cscMasterId, setCscMasterId] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [subareaId, setSubareaId] = useState("");
  const [cscName, setCscName] = useState("");
  const [cscCode, setCscCode] = useState("");
  const [customerOptions, setCustomerOptions] = useState([]);
  const { user } = useSelector((state) => state.auth);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState(null);
  const [rowData, setRows] = useState([]);
  const [updatedSubAreaId, setupdatedSubAreaId] = useState("");
  //=======================================================================

  const eisId = user.eisId;

  //=========================================================================================================//
  // const handleSearchChange = (e) => {
  //     setSearchInput(e.target.value);
  //     setPage(1);
  //     setFirstVisiblePage(1);
  // };
  //=========================================================================================================//
  const fetchData = async (loggedCscId, loggedSubareaId) => {
    const updatedCustomerCode = selectedCustomer.map((cusCode) => {
      return cusCode.value;
    });
    try {
      setLoading(true);
      const requestParams = {
        pageNo: page,
        limit: parseInt(pageLimit),
        customerCode: updatedCustomerCode,
        loggedUserId: eisId,
        loggedSubareaId: parseInt(loggedSubareaId),
        loggedCscId: parseInt(loggedCscId),
        fromDate: fromDate,
        toDate: toDate,
      };

      const responseData = await quotationList(requestParams).then(
        (response) => response.data
      );
      setData(responseData.data);
      getRowsData(responseData.data);
      setPagination(responseData.pagination);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  function getRowsData(rowData) {
    const output = rowData.map((obj) => ({
      pricingNo: obj.pricingNo,
      pricingDate: obj.updatedAt,
      createdBy: obj.createdBy,
      loggedCsc: obj.loggedCsc,
      pricingFor: obj.pricingFor,
      customerCode: obj.customerCode,
      factoryCode: obj.factoryCode,
      currency: obj.currency,
      count: obj.count,
      action: obj._id,
    }));

    setRows(output);
    setTableData(output);
    //ReactTooltip.rebuild();
  }

  //==========================================================================================================//

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  //===========================================================================================================//
  // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    const getCscMasterList = async () => {
      try {
        const requestParams = {
          UserId: eisId,
        };
        const cscList = await userCSCMappingList(requestParams).then(
          (response) => response.data
        );

        setCscMaster(cscList.data);
        if (
          !currentUser.state?.loggedCscId ||
          !currentUser.state?.loggedSubareaId ||
          !currentUser.state?.loggedCscName
        ) {
          currentUser.stateHandle({
            loggedCscId: cscList.data[0].CSCId,
            loggedSubareaId: cscList.data[0].SubareaId,
            loggedCscName: cscList.data[0].CSCName,
          });
        } else {
          setCscMasterId(currentUser.state?.loggedCscId);
          setSubareaId(currentUser.state?.loggedSubareaId);
          setCscName(currentUser.state?.loggedCscName);
          setCscCode(currentUser.state?.loggedCscCode);
          currentUser.stateHandle({
            loggedCscId: currentUser.state?.loggedCscId,
            loggedSubareaId: currentUser.state?.loggedSubareaId,
            loggedCscName: currentUser.state?.loggedCscName,
          });
        }
        const localStorageCscId = localStorage.getItem("loggedCscId");
        const localStorageSubareaId = localStorage.getItem("loggedSubareaId");
        const localStorageCscName = localStorage.getItem("loggedCscName");

        if (localStorageCscId && localStorageSubareaId && localStorageCscName) {
          setCscMasterId(localStorageCscId);
          setSubareaId(localStorageSubareaId);
          setCscName(localStorageCscName);

          fetchData(localStorageCscId, localStorageSubareaId);
        } else {
          setCscMasterId(cscList.data[0].CSCId);
          setSubareaId(cscList.data[0].SubareaId);
          setCscName(cscList.data[0].CSCName);

          localStorage.setItem("loggedCscId", cscList.data[0].CSCId);
          localStorage.setItem("loggedSubareaId", cscList.data[0].SubareaId);
          localStorage.setItem("loggedCscName", cscList.data[0].CSCName);

          fetchData(cscList.data[0].CSCId, cscList.data[0].SubareaId);
        }
      } catch (err) {
        console.error("Error in getCscMasterList:", err);
      }
    };

    // Call the functions
    getCscMasterList();

    if (currentUser.state?.loggedCscId && currentUser.state?.loggedSubareaId) {
      // Use the values from the user state

      setCscMasterId(currentUser.state?.loggedCscId);
      setSubareaId(currentUser.state?.loggedSubareaId);
    }
  }, [page, pageLimit, searchInput, eisId]); // eslint-disable-line react-hooks/exhaustive-deps
  //===========================================================================================================//
  const navigate = useNavigate();
  const handleEditClick = (pricingNo) => {
    navigate(`/Pricing/pricingNo=${pricingNo}`);
  };

  const handleDeleteClick = (quotation_id) => {
    setShowDeleteModal(true);
    setQuotationIdToDelete(quotation_id);
  };

  const handleConfirmDelete = async (e) => {
    e.preventDefault();

    const requestData = { quotationId: quotationIdToDelete };

    try {
      const response = await quotationDelete(requestData).then(
        (response) => response.data
      );
      
      if (response?.data) {
        await fetchData(cscMasterId, subareaId);
      } else {
        console.error("Invalid data structure after deletion:", response);
      }
    } catch (err) {
      // console.log("Error Msg", err);
    } finally {
      setShowDeleteModal(false);
      setQuotationIdToDelete(null);
    }
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
    setQuotationIdToDelete(null);
  };

  // const filteredData = data && data.filter((item) =>
      
  //     Object.values(item).some((value) => value && value.toString().toLowerCase().includes(searchInput.toLowerCase()))
  // );

  //=========================================================================================================//

  const handleCustomerSelect = (selectedOption, { action }) => {
    if (action === "input-change" && selectedOption.length >= 4) {
      if (user.role === "user") {
        fetchCustomerUserList(selectedOption);
      } else {
        fetchCustomerAdminList(selectedOption);
      }
    }
  };

  const fetchCustomerUserList = async (selectedOption) => {
    try {
      setIsLoading(true);
      const requestBody = {
        EmployeeId: eisId,
        CSCId: cscMasterId,
        updatedSubAreaId,
      };

      const response = await userCustomerList(requestBody);

      const options = response.data.data.map((item) => ({
        value: item.MappedCustomerCode,
        label: `${item.MappedCustomerCode} - [${item.CustomerAliasName}]`,
      }));
      setCustomerOptions(options);
      setIsLoading(false);
      setupdatedSubAreaId(options.value);
    } catch (error) {
      //setError(error);
    }
  };

  const fetchCustomerAdminList = async (selectedOption) => {
    try {
      setIsLoading(true);
      const requestBody = {
        SubareaId: subareaId,
      };
      const res = await userMasterActiveList(requestBody);

      const options = res.data.data.map((item) => ({
        value: item.CustomerCode,
        label: `${item.CustomerCode} `
        // - [${item.LastName}]
        ,
        // lastName: item.LastName,
      }));
      setCustomerOptions(options);
      setIsLoading(false);
    } catch (error) {
      // setError(error);
    }
  };

  const SelectAllButton = ({ innerProps }) => {
    let button;

    if (selectedCustomer === 0) {
      button = (
        <button
          onClick={deselectAllOptions}
          style={{
            backgroundColor: "#dc3545", // Red color for deselect button
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            padding: "4px 16px",
            cursor: "pointer",
            fontSize: "14px",
          }}
        >
          &#x2717;
        </button>
      );
    } else {
      button = (
        <button
          onClick={selectAllOptions}
          style={{
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            padding: "4px 16px",
            cursor: "pointer",
            fontSize: "14px",
          }}
        >
          &#x2713;
        </button>
      );
    }

    return (
      <div {...innerProps} style={{ padding: "8px", textAlign: "center" }}>
        {button}
      </div>
    );
  };

  const DropdownIndicator = (props) =>
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <span>▼</span>
      </components.DropdownIndicator>
    );

  const selectAllOptions = (e) => {
    e.preventDefault();

    const optionsArray = customerOptions.map((cusOption, index) => ({
      label: cusOption.label,
      value: cusOption.value,
      isSearchable: true,
    }));

    setSelectedCustomer(optionsArray);
  };

  const deselectAllOptions = (e) => {
    e.preventDefault();
    setSelectedCustomer([]);
  };

  const clickReload = () => {
    window.location.reload();
  };

  const [sortField, setSortField] = useState("");
  const [order, setOrder] = useState("asc");
  const [tableData, setTableData] = useState([
    { label: "Pricing No", accessor: "pricingNo", sortable: true },
  ]);

  const handleSortingChange = (accessor) => {
    const sortOrder =
      accessor === sortField && order === "asc" ? "desc" : "asc";
    setSortField(accessor);
    setOrder(sortOrder);

    const sorted = [...tableData].sort((a, b) => {
      const valueA = a[accessor];
      const valueB = b[accessor];

      if (typeof valueA === "string") {
        return sortOrder === "asc"
          ? valueA?.localeCompare(valueB)
          : valueB?.localeCompare(valueA);
      } else {
        return sortOrder === "asc" ? valueA - valueB : valueB - valueA;
      }
    });
    setRows(sorted);
  };

  return (
    <>
      <div className="container-fluid pt-2 ">
        <div className="d-flex pt-1 pb-1 ">
          <div className="col-md-6 p-0">
            <div className="form-group mb-3 mb-md-0">
              <h3>Pricing</h3>
            </div>
          </div>
          <div className="col-md-6 d-flex justify-content-end p-0">
            <label htmlFor="selectCsc" className="form-label pr-2  mb-0">
              Switch CSC
            </label>
            <select
              className="form-control form-control-sm w-25 mt-2"
              required
              id="selectCsc"
              onChange={(e) => {
                const selectedValue = e.target.value;
                // console.log("🚀 ~ selectedValue:", selectedValue);

                const [cscId, subareaId, cscName] = selectedValue?.split("~");

                localStorage.setItem("loggedCscId", cscId);
                localStorage.setItem("loggedSubareaId", subareaId);
                localStorage.setItem("loggedCscName", cscName);

                setCscMasterId(cscId);
                setSubareaId(subareaId);
                setCscName(cscName);

                currentUser.stateHandle({
                  loggedCscId: cscId,
                  loggedSubareaId: subareaId,
                  loggedCscName: cscName,
                });
                fetchData(cscId, subareaId);
              }}
              value={`${cscMasterId}~${subareaId}~${cscName}`} // Set the selected value
            >
              {cscMaster?.map((list) => (
                <option
                  key={list.CSCId}
                  value={`${list.CSCId}~${list.SubareaId}~${list.CSCName}`}
                >
                  {list.CSCName} - {list.CSCId} -{list.CSCCode}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="row">
          <div className="col-md-1">
            {data?.length > 0 && (
              <div className="d-flex py-1">
                <h5 className="pt-1">
                  Total :{" "}
                  <span style={{ color: "#28a745", paddingLeft: "3px" }}>
                    {pagination.totalDocument}
                  </span>
                </h5>
              </div>
            )}
          </div>
          <div className="col-md-3">
            <Select
              value={selectedCustomer}
              onChange={(e) => setSelectedCustomer(e)}
              onInputChange={handleCustomerSelect}
              options={customerOptions}
              required
              defaultValue={selectedCustomer}
              className="style-select multiple-select"
              isSearchable={true}
              placeholder="Enter Customer Code & Select"
              isClearable={true}
              isMulti
              isLoading={isLoading}
              components={{
                DropdownIndicator,
                Option: (props) => <components.Option {...props} />,
                Menu: (props) => (
                  <components.Menu {...props}>
                    {props.children}
                    <SelectAllButton />
                  </components.Menu>
                ),
              }}
              styles={{
                multiValueLabel: (base) => ({
                  ...base,
                  color: "blue",
                }),
                control: (base) => ({
                  ...base,
                  minHeight: "40px",
                }),
              }}
            />
          </div>
          <div className="col-md-3">
            <DatePicker
              className="form-control"
              value={fromDate}
              onChange={(date, format) => {
                if (!date) {
                  setFromDate("");
                } else {
                  // const formattedDate = date.split("T")[0];
                  setFromDate(date);
                }
              }}
              placeholder="From Date"
            />
          </div>
          <div className="col-md-3">
            <DatePicker
              className="form-control"
              value={toDate}
              onChange={(date, format) => {
                if (!date) {
                  setToDate(""); // Clear the toDate state
                } else {
                  //let updateDate = date.split("T")[0];
                  setToDate(date);
                }
              }}
              placeholder="To Date"
            />
          </div>
          <div className="col-md-2">
            <div className="d-flex justify-content-end">
              <Button className="btn btn-warning ml-3" onClick={clickReload}>
                <FontAwesomeIcon icon={faArrowRotateRight} />
              </Button>
              <button
                className="btn btn-primary ml-4"
                onClick={() => fetchData(cscMasterId, subareaId)}
              >
                Search
              </button>

              <Link to="/Pricing" className="addBtn ml-4">
                <FontAwesomeIcon icon={faPlus} />
              </Link>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="pt-2 d-flex justify-content-center align-items-center">
            <Loading />
          </div>
        ) : (
          <>
            {data?.length > 0 ? (
              <div
                className="table-responsive"
                style={{ overflowY: "auto", height: "75vh" }}
              >
                <table className="smartTable-table table table-striped border">
                  <thead className="Thead">
                    <tr>
                      {columnPricingTableData?.map(
                        ({ label, accessor, sortable }) => {
                          const cl = sortable
                            ? sortField &&
                              sortField === accessor &&
                              order === "asc"
                              ? "up"
                              : sortField &&
                                sortField === accessor &&
                                order === "desc"
                              ? "down"
                              : "default"
                            : "";
                          return (
                            <th
                              key={accessor}
                              onClick={
                                sortable
                                  ? () => handleSortingChange(accessor)
                                  : null
                              }
                              className={`${cl} smartTable-pointer`}
                            >
                              {label}
                            </th>
                          );
                        }
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {rowData?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.pricingNo}</td>
                        {/* <td>{item.updatedAt}</td> */}
                        <td>
                          {moment(item.pricingDate).format(
                            "DD MMM YYYY, hh:mm A"
                          )}
                        </td>
                        <td>{item.createdBy}</td>
                        <td>{item.loggedCsc}</td>
                        <td>{item.pricingFor}</td>
                        <td>{item.customerCode}</td>
                        <td>{item.factoryCode}</td>
                        <td>{item.currency}</td>
                        <td>{item.count}</td>
                        <td>
                          <div className="d-flex">
                            <FontAwesomeIcon
                              icon={faPencil}
                              onClick={() => handleEditClick(item.pricingNo)}
                              style={{
                                cursor: "pointer",
                                color: "#007bff",
                                marginRight: "10px",
                              }}
                            />
                            <FontAwesomeIcon
                              icon={faTrash}
                              // size="sm"
                              type="button"
                              data-toggle="modal"
                              data-target="#exampleModal"
                              onClick={() => handleDeleteClick(item.action)}
                              style={{
                                cursor: "pointer",
                                color: "#dc3545",
                                marginLeft: "10px",
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="d-flex justify-content-center">
                <h2 style={{ color: "red" }}>No Records Found</h2>
              </div>
            )}
          </>
        )}

        {rowData?.length > 0 && (
          <>
            <div className="d-flex justify-content-between">
              <div className="pt-3 form-inline">
                <label className="m-0 pr-2 text-default">Page View :</label>
                <select
                  className="form-control"
                  value={pageLimit}
                  ref={selectPageLimitRef}
                  onChange={(e) => {
                    setPageLimit(e.target.value);
                    setPage(1);
                  }}
                >
                  {paginationList?.map((items) => (
                    <option key={items.label} value={items.value}>
                      {`${items.label}`}
                    </option>
                  ))}
                </select>
              </div>

              <div className="pt-3">
                <nav aria-label="Page navigation example">
                  <ul className="pagination">
                    <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(page - 1)}
                        disabled={page === 1}
                      >
                        <span aria-hidden="true">&laquo;</span>
                        <span className="sr-only">Previous</span>
                      </button>
                    </li>

                    {Array.from(
                      { length: pagination.totalPages },
                      (_, index) => index + 1
                    ).map((pageNumber) => (
                      <li
                        key={pageNumber}
                        className={`page-item ${
                          pageNumber === page && "active" 
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(pageNumber)}
                        >
                          {pageNumber}
                        </button>
                      </li>
                    ))}

                    <li
                      className={`page-item ${
                        page === pagination.totalPages ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(page + 1)}
                        disabled={page === pagination.totalPages}
                      >
                        <span aria-hidden="true">&raquo;</span>
                        <span className="sr-only">Next</span>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </>
        )}
      </div>

      {showDeleteModal && (
        <DeleteComponent
          handleCancelDelete={handleCancelDelete}
          handleConfirmDelete={handleConfirmDelete}
        />
      )}
    </>
  );
};

export default PricingTable;
